import { ApolloClient, ApolloLink } from '@apollo/client';
import { HttpLink, InMemoryCache, gql } from '@apollo/client/core';
import { SentryLink } from 'apollo-link-sentry';

import { authLink, embedTokenLink } from 'support/firebase/auth';

import { traceparentLink } from './traceparentLink';

const cache = new InMemoryCache({
  // The Team type has two denormalized relations, theme and features. Since these relations are one to one,
  // we can safely assume that properties across queries can be merged into one object. Apollo does not make this
  // assumption about denromalized relations and as such would invalidate cache entries for every new property queried on theme or features.
  typePolicies: {
    Organization: {
      fields: {
        theme: {
          merge: true,
        },
        features: {
          merge: true,
        },
      },
    },
    Team: {
      fields: {
        theme: {
          merge: true,
        },
        features: {
          merge: true,
        },
      },
    },
    User: {
      fields: {
        profile: {
          merge: true,
        },
      },
    },
  },
});

const httpLink = new HttpLink({
  uri: '/graphql',
});

export const apolloClient = new ApolloClient({
  cache,
  link: ApolloLink.from([
    new SentryLink({ attachBreadcrumbs: { includeError: true } }),
    embedTokenLink,
    authLink,
    traceparentLink,
    httpLink,
  ]),
  connectToDevTools: true,
  resolvers: {
    Mutation: {
      updateLocalTeam: (_, { id, team }, { cache }) => {
        cache.writeFragment({
          id: cache.identify({
            __typename: 'Team',
            id,
          }),
          fragment: gql`
            fragment BrandedTeam on Team {
              name
              logo
              title
              subtitle
              slug

              primary_link_text
              primary_link_url
              secondary_link_text
              secondary_link_url

              theme {
                foreground_color
                foreground_image
                background_color
                background_image
                primary_foreground_color
                primary_background_color
                secondary_foreground_color
                secondary_background_color
              }
            }
          `,
          data: team,
        });

        return team;
      },
    },
  },
});
